module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "on-close": _vm.close
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$store.getters.companyContent.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n            " + _vm._s(_vm.$store.getters.companyContent.body) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-75665c6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/NewContent.vue
// module id = 105
// module chunks = 0